import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import AutoLogout from '../AutoLogout';
import * as ROUTES from '../../constants/routes';

// For routes that require a user to be logged in
export const PrivateRoute = ({ authStatus }) => {
  if (authStatus === null) { // Still checking
    return <LinearProgress />;
  }
  return authStatus ? <><AutoLogout /><Outlet /></> : <Navigate to={ROUTES.LOGIN} replace />;
};

// For routes that should only be accessible when logged out (like Login, Signup)
export const PublicRoute = ({ authStatus }) => {
    if (authStatus === null) { // Still checking
        return <LinearProgress />;
    }
    // Redirects to the main app page if the user is already logged in
    return authStatus ? <Navigate to={ROUTES.APP} replace /> : <Outlet />;
};